"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdReact = _interopRequireDefault(require("@bit/gerenciatd.react.icon-library"));

var _gerenciatdReact2 = _interopRequireDefault(require("@bit/gerenciatd.react.icon"));

var _gerenciatdReact3 = _interopRequireDefault(require("@bit/gerenciatd.react.anchor-smooth"));

require("./AnchorSmoothList.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Stateless component to draw a AnchorSmooth.
 * @param {JSX} children Children to be rendered.
 * @param {string} anchorsArray Array with anchor info (text, alt and idToScroll)
 * @param {string} wrapperClass Wrapperclass to style this component
 * @param {number} offset Offset used if the sticky bar is floating
 * @returns {JSX} Component JSX.
 */
var AnchorSmoothList =
/*#__PURE__*/
function (_Component) {
  _inherits(AnchorSmoothList, _Component);

  function AnchorSmoothList(props) {
    var _this;

    _classCallCheck(this, AnchorSmoothList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnchorSmoothList).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "toggleCollapsed", function () {
      var toggled = _this.state.toggled;
      toggled = !toggled;

      _this.setState({
        toggled: toggled
      });
    });

    _this.state = {
      toggled: false
    };
    return _this;
  }

  _createClass(AnchorSmoothList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          anchorsArray = _this$props.anchorsArray,
          wrapperClass = _this$props.wrapperClass,
          offset = _this$props.offset;
      var toggled = this.state.toggled;
      var toggleClass = toggled ? 'anchorSmoothListToggled' : '';
      var classIcon = toggled ? _gerenciatdReact.default.flechaup : _gerenciatdReact.default.vdown;
      return _react.default.createElement("div", {
        className: "anchorSmoothList ".concat(toggleClass, " ").concat(wrapperClass)
      }, _react.default.createElement(_gerenciatdReact2.default, {
        classIcon: classIcon,
        title: "Ver opciones",
        onClick: this.toggleCollapsed,
        wrapperClass: "anchorSmoothToggleButton visible-xs"
      }), _react.default.createElement("ul", null, anchorsArray.map(function (anchorObj, key) {
        var idToScroll = anchorObj.idToScroll,
            alt = anchorObj.alt,
            text = anchorObj.text;
        return _react.default.createElement("li", {
          key: key.toString()
        }, _react.default.createElement(_gerenciatdReact3.default, {
          idToScroll: idToScroll,
          text: text,
          alt: alt,
          offset: offset
        }));
      })));
    }
  }]);

  return AnchorSmoothList;
}(_react.Component);
/*  Proptypes for the Card props */


AnchorSmoothList.propTypes = {
  anchorsArray: _propTypes.default.array.isRequired,
  wrapperClass: _propTypes.default.string,
  offset: _propTypes.default.number
};
/* Default values for non required props */

AnchorSmoothList.defaultProps = {
  wrapperClass: '',
  offset: 0
};
var _default = AnchorSmoothList;
exports.default = _default;

//# sourceMappingURL=index.js.map